import type { UnitPreferences, UnitPresetKey } from "verdi-common/Configurations/Units/UnitPresetsConfigurations";
import { UNIT_PRESET_KEYS, UNIT_PRESETS } from "verdi-common/Configurations/Units/UnitPresetsConfigurations";
import { useGetMyOrganizationSettings } from "@/api/orval/generated/organization";

/** Validates a raw API value against the known preset keys, falling back to the legacy preset. */
export function parseUnitPresetKey(raw: string | undefined): UnitPresetKey {
    const legacyKey = UNIT_PRESETS.VERDI_LEGACY.key;
    return raw && (UNIT_PRESET_KEYS as readonly string[]).includes(raw) ? (raw as UnitPresetKey) : legacyKey;
}

export type UseUnitPreferencesResult = {
    unitPreferences: UnitPreferences;
    unitPresetKey: UnitPresetKey;
    isLoading: boolean;
    isError: boolean;
    refetch: () => void;
};

/**
 * Derives the current user's unit preferences from their persisted org setting.
 * Falls back to VERDI_LEGACY until the query resolves or if the stored key is unrecognised.
 */
export function useUnitPreferences(): UseUnitPreferencesResult {
    const { data, isLoading, isError, refetch } = useGetMyOrganizationSettings();
    const unitPresetKey = parseUnitPresetKey(data?.unitPresetKey);

    return {
        unitPreferences: UNIT_PRESETS[unitPresetKey].units,
        unitPresetKey,
        isLoading,
        isError,
        refetch,
    };
}
